import { render, staticRenderFns } from "./LoanType.vue?vue&type=template&id=2d341c2f&scoped=true"
import script from "./LoanType.vue?vue&type=script&lang=js"
export * from "./LoanType.vue?vue&type=script&lang=js"
import style0 from "./LoanType.vue?vue&type=style&index=0&id=2d341c2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d341c2f",
  null
  
)

export default component.exports